import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * React Router preserves scroll position by default. For a long landing /
 * stats site that means tapping a nav link from the bottom of one page
 * drops you at the bottom of the next, mid-content. Reset on every
 * pathname change so each route starts at the top.
 *
 * Only triggers on pathname change, not search/hash — so links like
 * `/swap?slippage=100` or `#section` don't fight the user.
 */
export function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "instant" as ScrollBehavior });
    }, [pathname]);
    return null;
}
